import { render } from "./11TravellerInfo.vue?vue&type=template&id=646cf21d"
import script from "./11TravellerInfo.vue?vue&type=script&lang=js"
export * from "./11TravellerInfo.vue?vue&type=script&lang=js"

import "./11TravellerInfo.vue?vue&type=style&index=0&id=646cf21d&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__